var scope_0 = require('/home/runner/work/my-awesome-ds-2/my-awesome-ds-2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/826f2c02388494692f17a29dd1a6aaae.js').default;
var scope_1 = require('/home/runner/work/my-awesome-ds-2/my-awesome-ds-2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e63fd456f7543dc817e50bb4038f3ee7.js').default;
var scope_2 = require('/home/runner/work/my-awesome-ds-2/my-awesome-ds-2/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    